import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./indicador-cliente-listar/indicador-cliente-listar.module').then(m => m.IndicadorClienteListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./indicador-cliente-inserir/indicador-cliente-inserir.module').then(m => m.IndicadorClienteInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./indicador-cliente-editar/indicador-cliente-editar.module').then(m => m.IndicadorClienteEditarModule) }


    
    ])],
    exports: [RouterModule]
})
export class IndicadorClienteAppRoutingModule { }